import React from "react";

import { useType } from "api/hooks";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import TopProduct from "components/views/RecommendedProductView";

const RecommendedProductsList = () => {
  const location = useLocation();
  const { enginetypeid, gastype, catalyst } = queryString.parse(
    location.search
  );

  const { data } = useType(enginetypeid);

  const filteredData =
    data &&
    data.types.find(
      (d) => d.name === gastype && d.catalyst_fitted.toString() === catalyst
    );

  const first = filteredData && filteredData.products[0];
  return <TopProduct list={(first && [first]) || data} />;
};

RecommendedProductsList.displayName = "RecommendedProductsList";

export default RecommendedProductsList;
